(function () {
  'use strict';

  /*
   * =========================================================
   * PUBSUITE CONFIGURATION
   * =========================================================
   */

  var PUBSUITE_PRODUCT_ID = '1728522';

  var PUBSUITE_ACCESS_TOKEN =
    'feb5ff08d96715a6d766f3bb7894d3d276ebc2ce';


  /*
   * =========================================================
   * PUBSUITE STATE
   * =========================================================
   */

  var pubSuiteReady = false;

  var conversionQueue = [];

  /*
   * Prevent duplicate add_to_cart events when
   * both fetch and XMLHttpRequest detect the same request.
   */
  var lastAddToCartTime = 0;

  var ADD_TO_CART_DEBOUNCE = 1000;


  /*
   * =========================================================
   * SEND PUBSUITE CONVERSION
   * =========================================================
   */

  function sendPubSuiteConversion(eventName) {

    if (
      pubSuiteReady &&
      window.pubSuite &&
      typeof window.pubSuite.sendConversion === 'function'
    ) {

      window.pubSuite.sendConversion(eventName);

      console.log(
        'PubSuite: ' + eventName
      );

    } else {

      /*
       * PubSuite hasn't loaded yet.
       * Store the event and send it after initialization.
       */

      conversionQueue.push(eventName);

      console.log(
        'PubSuite not ready. Queued: ' + eventName
      );
    }
  }


  /*
   * =========================================================
   * LOAD PUBSUITE
   * =========================================================
   */

  function loadPubSuite() {

    /*
     * PubSuite already loaded.
     */

    if (window.pubSuite) {

      initializePubSuite();

      return;
    }


    /*
     * Prevent loading the script twice.
     */

    if (
      document.querySelector(
        'script[data-pubsuite-script="true"]'
      )
    ) {

      return;
    }


    var script =
      document.createElement('script');


    script.type =
      'text/javascript';


    script.src =
      'https://storage.googleapis.com/kochava-web-assets/ps/v1.8.0/pubsuite.js';


    script.async = true;


    script.setAttribute(
      'data-pubsuite-script',
      'true'
    );


    script.onload = function () {

      initializePubSuite();

    };


    script.onerror = function () {

      console.error(
        'PubSuite failed to load'
      );

    };


    document.head.appendChild(script);
  }


  /*
   * =========================================================
   * INITIALIZE PUBSUITE
   * =========================================================
   */

  function initializePubSuite() {

    if (!window.pubSuite) {

      console.error(
        'PubSuite object is unavailable'
      );

      return;
    }


    /*
     * Don't initialize twice.
     */

    if (pubSuiteReady) {
      return;
    }


    window.pubSuite.startWithProductId(
      PUBSUITE_PRODUCT_ID,
      PUBSUITE_ACCESS_TOKEN
    );


    pubSuiteReady = true;


    console.log(
      'PubSuite initialized'
    );


    /*
     * -------------------------------------------------------
     * PAGE VIEW
     * -------------------------------------------------------
     */

    sendPubSuiteConversion(
      'page_view'
    );


    /*
     * -------------------------------------------------------
     * SEND QUEUED EVENTS
     * -------------------------------------------------------
     */

    if (conversionQueue.length) {

      var queuedEvents =
        conversionQueue.slice();

      conversionQueue = [];


      queuedEvents.forEach(
        function (eventName) {

          sendPubSuiteConversion(
            eventName
          );

        }
      );
    }


    console.log(
      'PubSuite ready'
    );
  }


  /*
   * =========================================================
   * ADD TO CART
   * =========================================================
   *
   * Supports:
   *
   * Horizon
   *   /cart/add.js
   *
   * Trade
   *   /cart/add
   *
   * Supports:
   *
   * fetch()
   * XMLHttpRequest
   *
   * =========================================================
   */

  function trackAddToCart() {

    var now =
      Date.now();


    /*
     * Prevent duplicate events when both
     * fetch and XHR detect the same request.
     */

    if (
      now - lastAddToCartTime <
      ADD_TO_CART_DEBOUNCE
    ) {

      console.log(
        'PubSuite: duplicate add_to_cart ignored'
      );

      return;
    }


    lastAddToCartTime =
      now;


    console.log(
      'PubSuite: add_to_cart detected'
    );


    sendPubSuiteConversion(
      'add_to_cart'
    );
  }


  /*
   * ---------------------------------------------------------
   * CHECK CART URL
   * ---------------------------------------------------------
   */

  function isCartAddUrl(url) {

    if (
      typeof url !== 'string'
    ) {

      return false;
    }


    /*
     * Horizon:
     * /cart/add.js
     *
     * Trade:
     * /cart/add
     */

    return (
      url.includes('/cart/add.js') ||
      url.includes('/cart/add?') ||
      url.endsWith('/cart/add')
    );
  }


  /*
   * ---------------------------------------------------------
   * FETCH
   * ---------------------------------------------------------
   */

  if (
    typeof window.fetch === 'function'
  ) {

    var originalFetch =
      window.fetch;


    window.fetch =
      function () {

        var args =
          arguments;


        var url =
          args[0]?.url ||
          args[0];


        return originalFetch
          .apply(
            this,
            args
          )
          .then(
            function (response) {

              /*
               * Only track successful requests.
               */

              if (
                isCartAddUrl(url) &&
                response.ok
              ) {

                console.log(
                  'PubSuite: successful fetch cart add'
                );


                trackAddToCart();
              }


              return response;

            }
          );
      };
  }


  /*
   * ---------------------------------------------------------
   * XMLHTTPREQUEST
   * ---------------------------------------------------------
   */

  var originalXHROpen =
    XMLHttpRequest.prototype.open;


  var originalXHRSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open =
    function (
      method,
      url
    ) {

      this._pubSuiteCartUrl =
        url;


      return originalXHROpen.apply(
        this,
        arguments
      );
    };


  XMLHttpRequest.prototype.send =
    function () {

      var xhr =
        this;


      if (
        isCartAddUrl(
          xhr._pubSuiteCartUrl
        )
      ) {

        xhr.addEventListener(
          'load',
          function () {

            /*
             * HTTP 2xx = successful cart add.
             */

            if (
              xhr.status >= 200 &&
              xhr.status < 300
            ) {

              console.log(
                'PubSuite: successful XHR cart add'
              );


              trackAddToCart();
            }

          }
        );
      }


      return originalXHRSend.apply(
        this,
        arguments
      );
    };


  /*
   * =========================================================
   * SIGN UP
   * =========================================================
   *
   * Shopify customer registration form:
   *
   * form_type=create_customer
   *
   * This prevents login forms from triggering
   * sign_up.
   * =========================================================
   */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;


      if (
        !form ||
        form.tagName !== 'FORM'
      ) {

        return;
      }


      var createCustomerField =
        form.querySelector(
          'input[name="form_type"][value="create_customer"]'
        );


      if (
        !createCustomerField
      ) {

        return;
      }


      console.log(
        'PubSuite: sign_up detected'
      );


      sendPubSuiteConversion(
        'sign_up'
      );

    },
    true
  );


  /*
   * =========================================================
   * VIDEO VIEW
   * =========================================================
   *
   * Tracks the first play of each HTML5 video.
   *
   * Each video is only counted once per page.
   * =========================================================
   */

  document.addEventListener(
    'play',
    function (event) {

      var video =
        event.target;


      if (
        !video ||
        video.tagName !== 'VIDEO'
      ) {

        return;
      }


      /*
       * Already tracked?
       */

      if (
        video.dataset.pubSuiteTracked ===
        'true'
      ) {

        return;
      }


      /*
       * Mark this video as tracked.
       */

      video.dataset.pubSuiteTracked =
        'true';


      console.log(
        'PubSuite: video_view detected'
      );


      sendPubSuiteConversion(
        'video_view'
      );

    },
    true
  );


  /*
   * =========================================================
   * INITIALIZE
   * =========================================================
   */

  loadPubSuite();

})();